import AgyleDialog from '../../modal/agyleDialog';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';
import {useEffect, useState} from 'react';
import {Checkbox, FormControl, FormControlLabel} from '@mui/material';
import AgyleDatePicker from '../../ui/fields/agyleDatePicker';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import AgyleSelectField from '../../ui/selector/agyleSelectField';
import AgyleBlockSwitch from '../../ui/switch/agyleBlockSwitch';
import AgyleTextField from '../../ui/fields/agyleTextField';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import {updateBedasStatus} from '../../../store/reducers/ward';
import {useDispatch, useSelector} from 'react-redux';
import uuidv4 from 'uuid/v4';
import AgyleButton from '../../ui/buttons/agyleButton';
import InformationBox from '../../other/informationBox';
import config from '../../../app/config';
import {wardMapObject} from '../../../store/reducers/wardMap';

const useStyles = makeStyles(theme => ({
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  centerFlex: {
    display: 'flex',
    alignItems: 'center'
  },
  barsBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  }
}));


const DAYS_OF_WEEK = [
  {id: 'Mon', name: 'Mon', value: '1'},
  {id: 'Tue', name: 'Tue', value: '2'},
  {id: 'Wed', name: 'Wed', value: '3'},
  {id: 'Thu', name: 'Thu', value: '4'},
  {id: 'Fri', name: 'Fri', value: '5'},
  {id: 'Sat', name: 'Sat', value: '6'},
  {id: 'Sun', name: 'Sun', value: '7'},
];

const TIME_INTERVAL = [
  {id: 'week', name: 'Every Week', value: 'week'},
  {id: '2week', name: 'Every Two Weeks', value: '2week'},
  {id: '3week', name: 'Every Three Weeks', value: '3week'},
  {id: '4week', name: 'Every Four Weeks', value: '4week'},
];

export const CUSTOM_INTERVAL_OPTIONS = [
  {id: 'day', name: 'Day', value: 'day'},
  {id: 'week', name: 'Week', value: 'week'},
  {id: 'month', name: 'Month', value: 'month'},
];

const INITIAL_STATE = {
  daysOfWeek: [],
  startTime: null,
  startDate: null,
  endTime: null,
  endDate: null,
  intervalModeOn: true,
  intervalType: null,
  customInterval: null,
  customIntervalNumber: null,
  customIntervalType: null,
  active: true,
  locked: false,
  lockedReason: "",
}


export const getSessionStartDate = (session, temporaryLock) => {
  const bedasStart = moment(temporaryLock ? session?.from : session?.startDate);
  return bedasStart.toISOString();
}

export const getSessionEndDate = (session, temporaryLock) => {
  const bedasEnd = temporaryLock ? moment(session?.to) : moment(session?.startDate).set({hours: moment(session?.endDate).hours(), minutes: moment(session?.endDate).minutes()});
  return bedasEnd.toISOString();
}

export const calculateSessionTop = (session, selectedDay, sessionSlotHeight, sessionOffset, temporaryLock) => {
  const startDate = getSessionStartDate(session, temporaryLock);
  const minutesFromStartOfDay = moment(startDate).diff(moment(startDate).startOf('day'), 'minutes');
  const hoursFromStartOfDay = minutesFromStartOfDay / 60;

  const top = (hoursFromStartOfDay * sessionSlotHeight * 2) + sessionOffset;

  return `${top}px`;
}

export const calculateSessionWidth = (DEFAULT_LEFT) => {
  return `calc(100% - ${DEFAULT_LEFT}px)`
}

const calculateDuration = (start, end) => {
  return moment.duration(moment(end).diff(moment(start))).asMinutes();
};

export const calculateSessionHeight = (session, selectedDay, sessionSlotHeight, sessionOffset, temporaryLock) => {
  const startDate = getSessionStartDate(session, temporaryLock);
  const endDate = getSessionEndDate( session, temporaryLock );

  const durationInMinutes = calculateDuration(startDate, endDate);
  const height = (durationInMinutes / 30) * sessionSlotHeight - sessionOffset * 2;
  return `${height}px`;
}

export const getActiveSessions = (bedasSessions, selectedDay) => {
  if (!bedasSessions || _.isEmpty(bedasSessions)) return [];

  const valid = _.filter(bedasSessions, session => {
    if (!session?.active) return;

    const startDate = moment(session?.startDate);
    const endDate = moment(session?.endDate);

    if (moment(selectedDay).isBetween(startDate, endDate, null, '[]') ||
      moment(selectedDay).isSame(startDate, 'day') ||
      moment(selectedDay).isSame(endDate, 'day')) {
      return true
    }
  });

  return valid;
}

const cleanHour = (date) => moment(date).set({hours: 0, minutes: 0});

const checkDefaultInterval = (session, selectedDay) => {
  const startDate = moment(session.startDate);

  switch (session?.intervalType) {
    case 'week':
      return session;
    case '2week':
      return moment(selectedDay).diff(cleanHour(startDate), 'weeks') % 2 === 0;
    case '3week':
      return moment(selectedDay).diff(startDate, 'weeks') % 3 === 0;
    case '4week':
      return moment(selectedDay).diff(startDate, 'weeks') % 4 === 0;
    default:
      return false;
  }
}

const checkIfSessionIsOnSelectedDayOrDayBeforeAfter = (session, selectedDay) => {
  const startDate = moment(session.startDate);
  const endDate = moment(session.endDate);

  if (
    (startDate.isBefore(selectedDay) || startDate.isSame(selectedDay)) &&
    (endDate.isSame(selectedDay) || endDate.isSame(selectedDay, 'day', 'next'))
  ) {
    return session;
  }
}

const getSessionsOnSelectedDay = (session, selectedDay) => {
  const startDate = moment(session.startDate);
  const endDate = moment(session.endDate);

  if (startDate.isSame(selectedDay, 'day') && endDate.isSame(selectedDay, 'day')) {
    return session;
  }
}

const checkCustomInterval = (session, selectedDay) => {
  const startDate = moment(session.startDate).set({hours: 0, minutes: 0});

  const selectedClean = moment(selectedDay).set({hours: 0, minutes: 10});
  switch (session?.customIntervalType) {
    case 'day':
      return getSessionsOnSelectedDay(session, selectedDay) || moment(selectedClean).diff(startDate, 'days') % parseInt(session.customIntervalNumber  , 10) === 0;
    case 'week':
      return checkIfSessionIsOnSelectedDayOrDayBeforeAfter(session, selectedDay) ||  moment(selectedDay).diff(startDate, 'weeks') % parseInt(session.customIntervalNumber, 10)  === 0;
    case 'month':
      return checkIfSessionIsOnSelectedDayOrDayBeforeAfter(session, selectedDay) ||  moment(selectedDay).diff(startDate, 'months') % parseInt(session.customIntervalNumber, 10)  === 0;
    default:
      return false;
  }
}

export const getActiveSessionsByDay = (validActive, selectedDay) => {
  if (_.isEmpty(validActive)) return [];

  const repeatableSessions = _.filter(validActive, session => {

    if (_.isEmpty(session?.daysOfWeek)) {
      if (session?.customInterval) {
        return checkCustomInterval(session, selectedDay) || getSessionsOnSelectedDay(session, selectedDay)
      }
    }

    if (!_.isEmpty(session?.daysOfWeek) && session?.daysOfWeek.includes(`${moment(selectedDay).isoWeekday()}`)) {
      if (!session?.customInterval) {
        return checkDefaultInterval(session, selectedDay) || getSessionsOnSelectedDay(session, selectedDay);
      } else {
        return checkCustomInterval(session, selectedDay);
      }
    }
  });

  return repeatableSessions;
}

const INIT_ERROR_STATE = {
  startTime: false,
  startDate: false,
  endTime: false,
  endDate: false,
}

const BedasSessionsManager = (props) => {
  const classesLocal = useStyles();
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const mapObject = useSelector(wardMapObject);

  const [sessionState, setSessionState] = useState(INITIAL_STATE);
  const [customIntervalOptions, setCustomIntervalOptions] = useState(CUSTOM_INTERVAL_OPTIONS);
  const [errorState, setErrorState] = useState(INIT_ERROR_STATE)
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const filteredOptions = _.filter(CUSTOM_INTERVAL_OPTIONS, option => option?.id !== 'day');
    const emptyDaysOfWeek = () => _.isEmpty(sessionState.daysOfWeek);

    sessionState.customInterval && emptyDaysOfWeek() ?  setCustomIntervalOptions(filteredOptions) : setCustomIntervalOptions(CUSTOM_INTERVAL_OPTIONS);
  }, [sessionState.customInterval, sessionState.daysOfWeek])

  useEffect(() => {
    if (props?.sessionRef && props?.sessionRef?.current) {
      onEditSession(props?.sessionRef?.current);
    }
  },[props?.sessionRef, props.open, props.close])

  const handleChangeSessionState = (key, value) => {
    setSessionState(prevState => ({
      ...prevState,
      [key]: value
    }))
  }

  const getMomentDate = (date) => {
    return moment(date).set({hours: 0, minutes: 0, seconds: 0});
  }

  const getMomentTime = (date) => {
    return moment(date);
  }

  const onEditSession = () => {
    const sessionEditData = props.sessionRef.current;

    let data = {
      ...sessionState,
      ...sessionEditData,
      sessionId: sessionEditData?.sessionId,
      active: sessionEditData?.active,
      startDate: getMomentDate(sessionEditData?.startDate),
      startTime: getMomentTime(sessionEditData?.startDate),
      endDate: getMomentDate(sessionEditData?.endDate),
      endTime: getMomentTime(sessionEditData?.endDate),
    };

    setSessionState(data);
    checkEndTimeValid(data);
    setEditMode(true);
  }

  const handleDaysOfWeekChange = (event) => {
    let copy = _.cloneDeep(sessionState.daysOfWeek);

    if (!copy.includes(event.target.value)) {
      handleChangeSessionState('daysOfWeek', [...copy, event.target.value]);
    } else {
      const index = copy.findIndex(isoWeekday => isoWeekday === event.target.value);
      copy.splice(index, 1);

      handleChangeSessionState('daysOfWeek', copy);
    }
  };

  const checkMinutesValidity = (event) => {
    if (parseInt(event.target.value, 10) < 0) {
      event.target.value = 0;
    }

    return event.target.value
  }

  const handleCustomIntervalNumberChange = (event) => {
    const keyValue = checkMinutesValidity(event);
    handleChangeSessionState('customIntervalNumber', keyValue);
  }

  const handleStartTimeChange = (event) => {
    handleChangeSessionState('startTime', event);
  };

  const handleStartDateChange = (event) => {
    handleChangeSessionState('startDate', event);
  };

  const handleEndTimeChange = (event) => {
    handleChangeSessionState('endTime', event);
  };

  const handleEndDateChange = (event) => {
    handleChangeSessionState('endDate', event);
  };

  const handleIntervalTypeChange = (value) => {
    handleChangeSessionState('intervalType', value);
  };

  const handleChangeCustomIntervalType = (value) => {
    handleChangeSessionState('customIntervalType', value);
  };

  const handleChangeCustomInterval = (value) => {
    handleChangeSessionState('customInterval', value);
  }

  const handleChangeIntervalModeOn = (value) => {
    handleChangeSessionState('intervalModeOn', value);
  }

  const handleLockedReasonChange = (event) => {
    handleChangeSessionState('lockedReason', event.target.value);
  }

  const resetStateAndClose = (close = true) => {
    setSessionState(INITIAL_STATE);
    setEditMode(false);
    if (close) props.onClose();
  }

  useEffect(() => {
    if (sessionState.startDate && !sessionState.endDate) {
      handleEndDateChange(sessionState.startDate);
    }
  }, [sessionState?.startDate, sessionState?.endDate])

  const prepareUpdateData = () => {
      let dataToSend = {
        ...sessionState,
        sessionId: sessionState.sessionId,
        startDate: moment(sessionState.startDate).set({hours: sessionState.startTime.hours(), minutes: sessionState.startTime.minutes()}).toISOString(),
        endDate: moment(sessionState.endDate).set({hours: sessionState.endTime.hours(), minutes: sessionState.endTime.minutes()}).toISOString(),
        active: sessionState.active,
        locked: sessionState.locked,
      }

      if (dataToSend?.locked) {
        dataToSend.lockedReason = sessionState.lockedReason;
      }

      for (let key in dataToSend) {
        if (key === 'startTime' || key === 'endTime') delete dataToSend[key];
        if (dataToSend[key] === null || dataToSend[key] === undefined) delete dataToSend[key];
      }

      return dataToSend
  }

  const handleSubmit = () => {
    if (editMode) {
      const dataToSend = prepareUpdateData();
      dispatch(updateBedasStatus(mapObject?.hospitalId, dataToSend, resetStateAndClose, 'update'));
      return
    }

    let dataToSend = {
      sessionId: props.sessionId || uuidv4(),
      startDate: moment(sessionState.startDate).set({hours: sessionState.startTime.hours(), minutes: sessionState.startTime.minutes()}).toISOString(),
      endDate: moment(sessionState.endDate).set({hours: sessionState.endTime.hours(), minutes: sessionState.endTime.minutes()}).toISOString(),
      active: sessionState.active,
      locked: sessionState.locked,
    }

    if (!_.isEmpty(sessionState.daysOfWeek)) {
      dataToSend.daysOfWeek = sessionState.daysOfWeek;
    }

    if (sessionState.intervalModeOn) {
      dataToSend.intervalType = sessionState.intervalType;
      dataToSend.customInterval = sessionState.customInterval;
      dataToSend.customIntervalNumber = sessionState.customIntervalNumber;
      dataToSend.customIntervalType = sessionState.customIntervalType;
    }

    if (sessionState.locked) {
      dataToSend.lockedReason = sessionState.lockedReason;
    }

   for (let key in dataToSend) {
      if (dataToSend[key] === null || dataToSend[key] === undefined) {
        delete dataToSend[key];
      }
   }

   dispatch(updateBedasStatus(mapObject?.hospitalId, dataToSend, resetStateAndClose));
  }

  const checkEndDateValid = (state = sessionState) => {
    const valid = state.endDate && moment(state.endDate).isSameOrAfter(moment(state.startDate))
    setError('endDate', !valid)
  }

  const setError = (key, value = 0) => {
    setErrorState(prevState => ({
      ...prevState,
      [key]: value !== 0 ? value : true
    }))
  };

  const removeError = (key) => {
    setErrorState(prevState => ({
      ...prevState,
      [key]: false
    }))
  }

  const checkStartTimeValid = (state = sessionState) => {
    if (!state.startDate || !state.startTime) {
      setError('startTime');
      return;
    }

    if (moment.isMoment(state.startDate) && moment.isMoment(state.startTime)) {
      const startTimeBeforeNow = moment(state.startDate).set({
        hours: moment(state.startTime).hours(),
        minutes: moment(state.startTime).minutes()
      }).isBefore(moment());

      if (startTimeBeforeNow && !state?.sessionId) {
        setError('startTime');
        return;
      }
    }

    removeError('startTime');
  }

  const checkStartDateValid = (state = sessionState) => {
    if (!state.startDate) {
      setError('startDate');
      return;
    }

    if (moment.isMoment(state.startDate)) {
      const startDateAfterNow = moment(state.startDate).isSameOrAfter(moment(), 'day');

      if (!startDateAfterNow && !state?.sessionId) {
        setError('startDate');
        return;
      }
    }

    removeError('startDate');
  }

  useEffect(() => {
    checkStartTimeValid(sessionState)
    checkEndTimeValid(sessionState)
    checkStartDateValid(sessionState)
    checkEndDateValid(sessionState)
  }, [sessionState?.startDate, sessionState?.startTime, sessionState?.endDate, sessionState?.endTime, editMode])

  const checkEndTimeValid = (state = sessionState) => {
    if (!state.endDate || !state.endTime || !state.startDate || !state.startTime ||
      moment(state.endTime).isBefore(moment(state.startTime) || moment(state.endTime).isSame(moment(state.startTime)))
    ) {
      setError('endTime');
      return;
    }

    if (moment.isMoment(state.endDate) &&
      moment.isMoment(state.endTime) &&
      moment.isMoment(state.startDate) &&
      moment.isMoment(state.startTime)) {

      const endTimeAfterStartTime = moment(state.endDate).set({
        hours: moment(state.endTime).hours(),
        minutes: moment(state.endTime).minutes()
      }).isAfter(moment(state.startDate).set({
        hours: state.startTime.hours(),
        minutes: state.startTime.minutes()
      }));
      if (!endTimeAfterStartTime) {
        setError('endTime');
        return;
      }
    }

    removeError('endTime');
    return;
  }

  const submitButtonDisabled = () => {
    if (!sessionState.endTime || !sessionState.startTime || !sessionState.startDate) {
      return true;
    }

    if (errorState.startDate || errorState.startTime || errorState.endDate || errorState.endTime) {
      return true;
    }

    if (sessionState.intervalModeOn && sessionState.customInterval !== null) {
      if (!sessionState.customInterval && sessionState.startDate && sessionState.endDate && _.isEmpty(sessionState.daysOfWeek)) {
        return true;
      }
      if (sessionState.customInterval === false && !sessionState.intervalType) {
        return true;
      }

      if (sessionState.customInterval && (!sessionState.customIntervalNumber || !sessionState.customIntervalType)) {
        return true;
      }
    }

    return false;
  }

  const setSessionEnabled = (value) => {
    handleChangeSessionState('active', value);
  }

  const setSessionLocked = (value) => {
    handleChangeSessionState('locked', value);
  }

  const buttons = () => {
    let btnArr = [
      <Grid item sx={{mr: 1}}>
        <AgyleBlockSwitch
          onChange={setSessionLocked}
          value={sessionState.locked}
          customLabels={{
            yes: t("Locked"),
            no: t("Unlocked")
          }}
        />
      </Grid>,
      <Grid item sx={{mr: 1}}>
        <AgyleBlockSwitch
          onChange={setSessionEnabled}
          value={sessionState.active}
          customLabels={{
            yes: t("Active"),
            no: t("Inactive")
          }}
        />
      </Grid>
    ];

    if (!editMode) {
      btnArr.push(
        <Grid item sx={{mr: 1}}>
          <AgyleButton
            onClick={() => resetStateAndClose(false)}
            variant="outlined"
            fullWidth
          >
            {t('Reset Values')}
          </AgyleButton>
        </Grid>
      )
    }

    return btnArr;
  }

  const handleClose = () => {
    resetStateAndClose();
    props.onClose();
  }

  const dialogTitle = `${editMode ? 'Edit' : 'Add'} ${config?.appointmentNotBedasLabel ? 'Appointment' : 'Follow Up'} Session`;

  return (
    <AgyleDialog
      onClose={handleClose}
      open={props.open}
      title={t(dialogTitle)}
      closeButtonOnHeader
      width="md"
      fullWidth
      onSave={handleSubmit}
      buttons={buttons()}
      disableSubmit={submitButtonDisabled()}
    >
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <InformationBox type='info'>
          {t("To submit please fill at least one Days of week option and valid time interval option.")}
        </InformationBox>
      </Grid>

      <Grid item xs={12} className={classesLocal.checkboxContainer}>
        <div>
          <Typography variant="body1" align="center" sx={{mb: 1}}>
            {t("Days of week")}
          </Typography>

          <FormControl style={{display: 'inline-block'}}>
            {DAYS_OF_WEEK.map((day) => (
              <FormControlLabel
                key={day.id}
                labelPlacement="top"
                control={
                  <Checkbox
                    checked={sessionState.daysOfWeek.includes(day.value)}
                    onChange={handleDaysOfWeekChange}
                    value={day.value}
                  />
                }
                label={day.name}
              />
            ))}
          </FormControl>
        </div>
      </Grid>

      <Grid item xs={12} sm={6}>
        <AgyleDatePicker
          type="date"
          label={t("Start Date")}
          value={sessionState.startDate}
          error={errorState.startDate}
          disablePast
          disableFuture={false}
          onChange={handleStartDateChange}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AgyleDatePicker
          type="time"
          label={t("Start Time")}
          value={sessionState.startTime}
          error={errorState.startTime}
          disablePast
          disableFuture={false}
          onChange={handleStartTimeChange}
        />
      </Grid>

      <Grid item xs={6}>
        <AgyleDatePicker
          type="date"
          label={t("End Date")}
          value={sessionState.endDate}
          disablePast
          disableFuture={false}
          error={errorState.endDate}
          onChange={handleEndDateChange}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AgyleDatePicker
          label={t("End Time")}
          type="time"
          value={sessionState.endTime}
          error={errorState.endTime}
          disablePast
          disableFuture={false}
          onChange={handleEndTimeChange}
        />
      </Grid>

      <Grid item xs={12} md={3} className={classesLocal.centerFlex}>
        <Typography
          variant="body1"
          align="center"
          sx={{pl: .5, mr: 1.5}}
        >
          {t("Repeat")}
        </Typography>

        <AgyleBlockSwitch
          onChange={handleChangeIntervalModeOn}
          value={sessionState.intervalModeOn}
          />
      </Grid>

      {sessionState.intervalModeOn && <Grid item xs={12} md={3} className={classesLocal.centerFlex}>
        <Typography
          variant="body1"
          align="center"
          sx={{pl: .5, mr: 1.5}}
        >
          {t("Custom")}
        </Typography>

        <AgyleBlockSwitch
          onChange={handleChangeCustomInterval}
          value={sessionState.customInterval}
        />
      </Grid>}

      {sessionState.intervalModeOn && sessionState.customInterval === false &&
        <Grid item xs={12} md={6}>
          <AgyleSelectField
            value={sessionState.intervalType}
            onChange={handleIntervalTypeChange}
            options={TIME_INTERVAL}
            label={t("Time Interval")}
            withBackground
          />
        </Grid>}

      {sessionState.intervalModeOn && sessionState.customInterval &&
        <Grid item xs={12} md={6}>
          <Grid container className={classesLocal.centerFlex} spacing={1}>
            <Grid item xs={3} md={2}>
              <Typography
                variant="body1"
                sx={{mr: 1.5, pl: .5}}
                >
                {t("Every")}
              </Typography>
            </Grid>

            <Grid item xs={3} md={2}>
              <AgyleTextField
                value={sessionState.customIntervalNumber}
                onChange={handleCustomIntervalNumberChange}
                type="number"
                fullWidth
                min={0}
              />
            </Grid>

            <Grid item xs={6} md={8}>
              <AgyleSelectField
                onChange={handleChangeCustomIntervalType}
                value={sessionState.customIntervalType}
                options={customIntervalOptions}
                label={t("Select Interval")}
                withBackground
                />
            </Grid>
          </Grid>
        </Grid>
      }
      {
        sessionState.locked && (
          <Grid item xs={12}>
            <AgyleTextField
              value={sessionState.lockedReason}
              onChange={handleLockedReasonChange}
              label={t("Reason for locking")}
              fullWidth
              multiline
            />
          </Grid>
        )
      }

      {config?.appointmentNotBedasLabel && (
          <Grid item xs={12} className={classesLocal.barsBtn}>
            <AgyleButton fullWidth variant="contained" onClick={null}>{t('BARS')}</AgyleButton>
          </Grid>
      )}
    </Grid>
    </AgyleDialog>
  )
}

export default BedasSessionsManager;